import { useCallback, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useBuyMinutesModalStore } from '@/features/pricing/buyMinutes';

import { useBalanceStore } from '@/entities/balance';
import { useEnterprisePaymentRequiredModalStore } from '@/entities/pricing';

import { PATHS } from '@/shared/constants/routes/paths';
import { useGlobalErrorsStore } from '@/shared/hooks/useGlobalErrorsStore';
import { logout } from '@/shared/lib/logout';
import { GLOBAL_ERROR_TYPE } from '@/shared/types/GlobalError';

export const useGlobalErrors = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const openBuyMinutesModal = useBuyMinutesModalStore((state) => state.open);
  const openEnterprisePaymentRequiredModal = useEnterprisePaymentRequiredModalStore((state) => state.open);

  const errorType = useGlobalErrorsStore((state) => state.errorType);
  const resetGlobalError = useGlobalErrorsStore((state) => state.resetGlobalError);

  const { canBuyMinutes, hasActiveSubscription, hasArchivedSubscription, hasEnterprisePlan } = useBalanceStore();

  const navigateToPricingPage = useCallback(() => {
    navigate(PATHS.pricing, {
      state: {
        path: `${location.pathname}${location.search}${location.hash}`,
        pricingEntryPoint: 'payment_required_redirect',
      },
    });
  }, [location.pathname, location.search, location.hash, navigate]);

  useEffect(() => {
    if (errorType === GLOBAL_ERROR_TYPE.PaymentRequired) {
      resetGlobalError();

      if (hasActiveSubscription && !hasEnterprisePlan && canBuyMinutes && hasArchivedSubscription) {
        openBuyMinutesModal();
        return;
      }

      if (hasEnterprisePlan) {
        openEnterprisePaymentRequiredModal();
        return;
      }

      navigateToPricingPage();
    }

    if (errorType === GLOBAL_ERROR_TYPE.InactiveUser) {
      void logout();
      resetGlobalError();
    }
  }, [
    hasArchivedSubscription,
    canBuyMinutes,
    errorType,
    hasActiveSubscription,
    hasEnterprisePlan,
    resetGlobalError,
    openBuyMinutesModal,
    navigateToPricingPage,
    openEnterprisePaymentRequiredModal,
  ]);
};
